import React from 'react';
import { ArrowRight } from 'lucide-react';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'whatsapp';
  fullWidth?: boolean;
  showIcon?: boolean;
  pulse?: boolean;
  href?: string;
}
export function Button({
  children,
  variant = 'primary',
  fullWidth = false,
  showIcon = true,
  pulse = false,
  href,
  className = '',
  onClick,
  ...props
}: ButtonProps) {
  const baseStyles = 'relative inline-flex items-center justify-center px-6 py-4 text-lg md:text-xl font-heading font-bold uppercase tracking-wide transition-all duration-200 rounded-sm border-2 border-charcoal active:translate-y-1 active:shadow-none no-underline cursor-pointer';
  const variants = {
    primary: 'bg-amber text-charcoal shadow-hard hover:bg-amber-dark',
    secondary: 'bg-charcoal text-white shadow-hard hover:bg-stone-800',
    whatsapp: 'bg-whatsapp text-white shadow-hard border-whatsapp hover:bg-green-600'
  };
  const widthClass = fullWidth ? 'w-full' : '';
  const pulseClass = pulse ? 'btn-amber-pulse' : '';
  const allClasses = `${baseStyles} ${variants[variant]} ${widthClass} ${pulseClass} ${className}`;
  const content = <>
      {children}
      {showIcon && <ArrowRight className="ml-2 h-6 w-6" strokeWidth={3} data-id="element-136" />}
    </>;
  if (href) {
    return <a href={href} target="_blank" rel="noopener noreferrer" className={allClasses} onClick={onClick as any} data-id="element-137">
        {content}
      </a>;
  }
  return <button className={allClasses} onClick={onClick} {...props} data-id="element-138">
      {content}
    </button>;
}